var _a, _b, _c;

export var Applications;

(function (Applications) {
  Applications[Applications["Unknown"] = 0] = "Unknown";
  Applications[Applications["EasyMail"] = 1] = "EasyMail";
  Applications[Applications["EasyTemplate"] = 2] = "EasyTemplate";
  Applications[Applications["FileExplorer"] = 3] = "FileExplorer";
  Applications[Applications["SocialIntranet"] = 4] = "SocialIntranet";
})(Applications || (Applications = {}));

export var Components;

(function (Components) {
  Components[Components["Unknown"] = 0] = "Unknown";
  Components[Components["Main"] = 1] = "Main"; // Intranet

  Components[Components["ShortcutsWP"] = 2] = "ShortcutsWP";
  Components[Components["NewsWP"] = 3] = "NewsWP";
  Components[Components["EventsWP"] = 4] = "EventsWP";
  Components[Components["TeamsSummaryWP"] = 5] = "TeamsSummaryWP";
  Components[Components["SitesSummaryWP"] = 6] = "SitesSummaryWP";
  Components[Components["RecentDocumentsWP"] = 7] = "RecentDocumentsWP";
  Components[Components["OnboardingWP"] = 8] = "OnboardingWP";
  Components[Components["FindColleagueWP"] = 9] = "FindColleagueWP"; //Easymail

  Components[Components["AddAttachment"] = 10] = "AddAttachment";
  Components[Components["UploadAttachment"] = 11] = "UploadAttachment";
  Components[Components["InsertSignature"] = 12] = "InsertSignature";
  Components[Components["ChangeUserProps"] = 13] = "ChangeUserProps"; //Easytemplate

  Components[Components["TeamsTab"] = 14] = "TeamsTab";
  Components[Components["PersonalTab"] = 15] = "PersonalTab";
  Components[Components["SharePointWP"] = 16] = "SharePointWP";
  Components[Components["SharePointExtension"] = 17] = "SharePointExtension"; //File explorer
  // ??
})(Components || (Components = {}));

export var Events;

(function (Events) {
  Events[Events["Initialization"] = 0] = "Initialization";
  Events[Events["Click"] = 1] = "Click";
  Events[Events["Event"] = 2] = "Event";
  Events[Events["Exception"] = 3] = "Exception";
})(Events || (Events = {}));
/**
 * For use internally
 */


export var InstrumentationKeys = (_a = {}, _a[Applications.Unknown] = "", _a[Applications.EasyMail] = "b457d278-9bec-4f23-9ab5-7a006a439fd5", _a[Applications.EasyTemplate] = "b457d278-9bec-4f23-9ab5-7a006a439fd5", _a[Applications.FileExplorer] = "b457d278-9bec-4f23-9ab5-7a006a439fd5", _a[Applications.SocialIntranet] = "b457d278-9bec-4f23-9ab5-7a006a439fd5", _a);
export var ApplicationNames = (_b = {}, _b[Applications.Unknown] = "Unknown", _b[Applications.EasyMail] = "Easymail", _b[Applications.EasyTemplate] = "Easytemplate", _b[Applications.FileExplorer] = "FileExplorer", _b[Applications.SocialIntranet] = "SocialIntranet", _b);
export var ComponentNames = (_c = {}, _c[Components.Unknown] = "Unknown", _c[Components.Main] = "", _c[Components.EventsWP] = "Events Web Part", _c[Components.FindColleagueWP] = "Find a colleague Web Part", _c[Components.NewsWP] = "News Web Part", _c[Components.OnboardingWP] = "Onboarding Web Part", _c[Components.RecentDocumentsWP] = "Recent documents Web Part", _c[Components.ShortcutsWP] = "Shortcuts Web Part", _c[Components.SitesSummaryWP] = "Sites summary Web Part", _c[Components.TeamsSummaryWP] = "Teams summary Web Part", _c[Components.UploadAttachment] = "Upload attachments pane", _c[Components.AddAttachment] = "Add attachments pane", _c[Components.InsertSignature] = "Insert signature pane", _c[Components.ChangeUserProps] = "User settings pane", _c[Components.TeamsTab] = "Teams tab", _c[Components.PersonalTab] = "Personal tab", _c[Components.SharePointWP] = "SharePoint Web Part", _c[Components.SharePointExtension] = "SharePoint extension", _c);